export const scrollToAnchor = (anchorId: string) => {
  const node = document.getElementById(anchorId);
  if (!node) return;
  node.scrollIntoView({ behavior: 'smooth', block: 'start' });
  window.history.replaceState(null, '', `#${anchorId}`);
};
